import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';

import dateHoursFields from '../../../form/dateHoursFields';

const workgroupForm: Form<Documentation> = {
  key: 'workgroups',
  title: 'Arbeitskreise',
  fields: [
    ...dateHoursFields,
    {
      key: 'topic',
      label: 'Thema',
      fieldTypes: 'text',
    },
  ],
};

export default workgroupForm;
